import React, { useEffect } from "react";
import { Provider, useSelector, useDispatch } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import {
  HashRouter as Router,
  Switch,
  Redirect,
  useHistory 
} from "react-router-dom";
import "moment/locale/es";
import { Route } from "components";
import { RootState } from "reducers";
import { Socket, SocketEvents, Constants, Globals } from 'utils';
import { AuthService } from 'services';
import * as Jetemit from 'jetemit';

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

// Public
import Home from 'screens/home';

// Auth
import Login from "screens/auth/login/login";
import Recover from "screens/auth/login/recover";
import Reset from "screens/auth/login/reset";
import Profile from "screens/profile";

// Admin
import AdminUsers from 'screens/admin/users/users';
import AdminHome from 'screens/admin/home/home';
import AdminMoney from 'screens/admin/money/physical';
import AdminMoneyDigital from 'screens/admin/money/digital';
import AdminMoneyLiquidity from 'screens/admin/money/liquidity';
import AdminMoneyClientDashboard from 'screens/admin/money/client-dashboard';
import AdminIncome from 'screens/admin/incomes/incomes';
import AdminPlans from 'screens/admin/plans/plans';
import AdminNews from 'screens/admin/news/news';
import AdminPayments from 'screens/admin/payments/payments';
import AdminChat from 'screens/admin/chat/chat';
import AdminInformation from 'screens/admin/chat/information';
import AdminReports from 'screens/admin/reports/reports';
import AdminSystem from 'screens/admin/system';

// Scripts
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";

// Styles
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import "./scss/main.scss";

const Container = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const getUser = async () => {
      const user = store.getState().user;
      if (user) {
        const res: any = await AuthService.checkUser({
          withoutLoading: true
        });
        if (res.user) {
          dispatch({
            type: 'SET_USER',
            payload: res.user
          });
        }
        else {
          Globals.showError("Lo sentimos, su usuario ha sido eliminado");
          close();
        }
      }
    }
    getUser();

    const close = async () => {
      await dispatch({
        type: 'SET_USER',
        payload: null
      }); 
      await dispatch({
        type: 'SET_ACCESS_TOKEN',
        payload: null
      }); 
      history.replace('/logout');
    }

    Socket.on(SocketEvents.UPDATE_USER,(data: any) => {
      const user = store.getState().user;
      if (user != null && user?.id == data.user_id) {
        getUser();
      }
    });
  },[]);

  return (
    <React.Fragment>
      <Switch>
        {/* Public */}
        <Route exact path="/" component={ Home } />

        {/* Auth */}
        <Route exact noAuth path="/login" component={ Login } />
        <Route exact auth path="/profile" component={ Profile } />
        <Route exact noAuth path="/recover" component={ Recover } />
        <Route exact noAuth path="/recover/:code" component={ Reset } />

        {/* Admin */}
        <Route exact admin path="/admin/users" component={ AdminUsers } />
        <Route exact admin path="/admin/home" component={ AdminHome } />
        <Route exact admin path="/admin/reports" component={ AdminReports } />
        <Route exact admin path="/admin/payments" component={ AdminPayments } />
        <Route exact admin path="/admin/money" component={ AdminMoney } />
        <Route exact admin path="/admin/money/digital" component={ AdminMoneyDigital } />
        <Route exact admin path="/admin/money/liquidity" component={ AdminMoneyLiquidity } />
        <Route exact admin path="/admin/money/cliente/:userId" component={ AdminMoneyClientDashboard } />
        <Route exact admin path="/admin/plans" component={ AdminPlans } />
        <Route exact admin path="/admin/news" component={ AdminNews } />
        <Route exact admin path="/admin/incomes" component={ AdminIncome } />
        <Route exact admin path="/admin/chat" component={ AdminChat } />
        <Route exact admin path="/admin/information" component={ AdminInformation } />
        { /* Layout con rutas anidadas: NO exact -> matchea /admin/system/{dashboard,cron,logs,backups} */ }
        <Route admin path="/admin/system" component={ AdminSystem } />

        <Redirect to="/" />
      </Switch>
    </React.Fragment>
  )
}

const App = () => (
  <Provider store={ store }>
    <PersistGate loading={ null } persistor={ persistor }>
      <Router>
        <Container />
      </Router>
    </PersistGate>
  </Provider>
);

export default App;
